export enum DirectionType {
  COLUMN = "col",
  ROW = "row",
}

export enum RadioType {
  BUTTON = "button",
  RADIO = "radio",
}

export enum ButtonType {
  NORMAL = "normal",
  BORDER = "border",
}

export enum ButtonColor {
  PRIMARY = "primary",
  DARK = "dark",
  NEGATIVE = "negative",
  WARNING = "warning",
  POSITIVE = "positive",
  WHITE = "white",
  NONE = "none",
}

export enum ButtonSize {
  LG = "lg",
  MD = "md",
  NORMAL = "normal",
  SM = "sm",
  XSM = "xsm",
  XS = "xs",
  INFOTITLE = "infoTitle",
  TABLE = "table",
  MANAGE_POPUP = "MANAGE_POPUP",
  MANAGE_POPUP_2 = "MANAGE_POPUP_2",
  IMAGE_VIEW = "image_view",
}

export enum ButtonIcon {
  DEL = "Delete",
  PLUS = "Plus",
  SETTING = "Setting",
  EXCEL = "Excel",
  MEMO = "Memo",
  CLOSED = "Closed",
  LOGOUT = "Logout",
  NEXTARROW = "NextArrow",
  PREVARROW = "PrevArrow",
  DOWNARROW = "DownArrow",
  UPARROW = "UpArrow",
  SORT = "sort",
  SEARCH = "Search",
  EDIT = "Edit",
}

export enum CommmonSVGType {
  CLOSE = "close",
}

export enum TabType {
  TEXT = "Text",
  BUTTON = "Button",
}

export enum CardTextBoxColor {
  PRIMARY = "primary",
  DARK = "dark",
  NEGATIVE = "negative",
  WARNING = "warning",
  POSITIVE = "positive",
  WHITE = "white",
}

export enum CardTextSize {
  LG = "lg",
  MD = "md",
  NORMAL = "normal",
  SM = "sm",
  XSM = "xsm",
  XS = "xs",
}

export enum CardTextIcon {
  ORDER_ALL = "ORDER_ALL",
  PAYMENT_READY = "PAYMENT_READY",
  PRODUCT_READY = "PRODUCT_READY",
  PURCHASE_CONFIRM = "PURCHASE_CONFIRM",
  AFTER_REJECT = "CANCEL_AFTER_PAYMENT",
  BEFORE_REJECT = "CANCEL_BEFORE_SYSTEM",
  SHIPPING = "SHIPPING",
  SHIPPING_COMPLETE = "SHIPPING_COMPLETE",
  SHIPPING_READY = "SHIPPING_READY",
}

export enum OrderType {
  DESC = "desc",
  ASC = "asc",
}
